module.exports = __webpack_public_path__ + "static/img/sidebar-1.cb55b0d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sidebar-1.jpg
// module id = /knc
// module chunks = 18